// World — each axis 50% bigger than the original 4000.
export const WORLD_W = 6000;
export const WORLD_H = 6000;
export const PLAYER_CAP = 50;

// Food counts scaled with area (1.5 × 1.5 = 2.25 × original counts) so
// density stays roughly constant. Bumped 25% on top of that.
export const FOOD_COUNT = 2110;
export const FOOD_MASS = 1;

// Super food (blue dots) — sparse, 10x mass value.
export const SUPER_FOOD_COUNT = 22;
export const SUPER_FOOD_MASS = 10;

// Power-up (yellow dots) — rare. When eaten, the player can eat
// other cells up to 1/BOOST_EAT_RATIO × their own mass for the
// duration. BOOST_EAT_RATIO = 0.8 means b can be 1.25× a.
export const POWERUP_FOOD_COUNT = 3;
export const POWERUP_DURATION_MS = 8_000;
export const BOOST_EAT_RATIO = 0.8;

export const TICK_HZ = 20;
export const TICK_MS = 1000 / TICK_HZ;
export const RENDER_DELAY_MS = 100;

export const START_MASS = 10;
// Minimum mass to split. Bumped from 35 to delay the first split a
// little so the early game has more time to breathe.
export const MIN_SPLIT_MASS = 50;
export const SPLIT_MERGE_DELAY_MS = 15_000;
export const SPLIT_BOOST_SPEED = 800;

export const EAT_MASS_RATIO = 1.25;
export const EAT_OVERLAP_FACTOR = 0.3;

export const RADIUS_K = 4;
// Cell speed: SPEED_FLOOR + SPEED_K / sqrt(mass).
// The additive floor keeps very large cells maneuverable without
// flattening the curve to a constant. Tuned so:
//   mass 10   → 200 u/s (starting speed)
//   mass 100  → 94 u/s
//   mass 1000 → 60 u/s
//   mass 5000 → 52 u/s
export const SPEED_K = 490;
export const SPEED_FLOOR = 45;

export const ORPHAN_GRACE_MS = 5_000;
export const INTEREST_MARGIN = 1.5;

// Camera auto-zoom: targetZoom = clamp(MIN_AUTO_ZOOM, sqrt(mass)/12, MAX_AUTO_ZOOM).
// MAX_AUTO_ZOOM = 1.0 keeps the view tight — past mass 144 the auto-
// camera locks in and the player can use the wheel for fine control.
// At MAX_AUTO_ZOOM, the visible world width is roughly 1× the css
// viewport width (≈31% of the 6000-wide world).
export const MIN_AUTO_ZOOM = 0.5;
export const MAX_AUTO_ZOOM = 1.0;
// Server uses this with a generous viewport half-diagonal so the
// interest area is at least as big as a fully-zoomed client sees.
export const VIEWPORT_HALF_DIAGONAL = 1500;

// Purple — extremely rare. Lets you eat ANY cell regardless of mass for the duration.
export const SLAYER_FOOD_COUNT = 1;
export const SLAYER_DURATION_MS = 5_000;

// Red — uncommon. +100% movement speed (2× base) for 20 s.
export const SPEED_FOOD_COUNT = 2;
export const SPEED_DURATION_MS = 20_000;
export const SPEED_MULTIPLIER = 2.0;

// Vacuum (colorless animated). Pulls food toward the player's cells at
// VACUUM_PULL_SPEED u/s. Effective pull radius per-cell is
// max(VACUUM_RADIUS, cellRadius(mass) * VACUUM_RADIUS_SCALE) so bigger
// cells have a wider gravity well.
export const VACUUM_FOOD_COUNT = 2;
export const VACUUM_DURATION_MS = 15_000;
export const VACUUM_RADIUS = 250;
export const VACUUM_RADIUS_SCALE = 5;
export const VACUUM_PULL_SPEED = 800;

// Portals: hardcoded two pairs (four total) — positions placed by World.
export const PORTAL_RADIUS = 80;
export const PORTAL_COOLDOWN_MS = 2_000;
